import { isBrowser } from "@/helpers/isBrowser";
import { NEXT_PUBLIC_CART_SERVICE_BASE_URL } from "@/libs/constants/auth";
import { setServerCartErrorMessage } from "@/redux/slice/cart/slice";

export interface SyncGuestCartPayload {
  patientId: string;
  cartId: string;
}

export interface SyncGuestCartResponse {
  success: boolean;
  message?: string;
}

export const syncGuestCartApi = async (
  payload: SyncGuestCartPayload,
  mobileNumber: string,
  authToken?: string,
  dispatch?: any
): Promise<void> => {
  const url = `${NEXT_PUBLIC_CART_SERVICE_BASE_URL}/public/user-cart/sync-guest-cart`;

  const headers: HeadersInit = {
    "Content-Type": "application/json",
    mobileNumber: mobileNumber,
  };

  // Add Authorization header if token is provided
  if (authToken) {
    headers["Authorization"] = authToken;
  }

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(payload),
    });

    const result: SyncGuestCartResponse = await response.json();

    if (!response.ok || !result?.success) {
      console.error("Failed to sync guest cart:", result);
      dispatch(
        setServerCartErrorMessage(
          result?.message || "Failed to sync guest cart"
        )
      );
      isBrowser() && localStorage?.removeItem("guestCartId");
      throw new Error(result?.message || "Failed to sync guest cart");
    }
    isBrowser() && localStorage?.removeItem("guestCartId");
    return;
  } catch (error) {
    console.error("Failed to sync guest cart:", error);
    throw error;
  }
};
